import { motion } from "framer-motion";

const WelcomeSection = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  const paragraphs = [
    "Welcome to Mr-Reel, your trusted source for expert insights into the world of online casinos. With over 20 years of experience in the gaming industry, we are committed to providing players with comprehensive, up-to-date, and unbiased reviews of the best online casinos, top-tier bonuses, and the fastest payout options available.",
    "At Mr-Reel, we understand that every player has unique preferences, from high-stakes gaming to casual play. That's why our team of industry experts meticulously evaluates and compares online casinos, ensuring you have access to the most reliable, rewarding, and secure platforms.",
    "Our in-depth analysis considers key factors such as payout speeds, bonus terms, game variety, and customer support to help you make well-informed decisions.",
    "Our mission is to create a seamless and enjoyable gaming experience by connecting players with casinos that align with their individual needs. Whether you're seeking exclusive promotions, VIP programs, or simply a trustworthy platform to enjoy your favorite games, we strive to be your go-to resource.",
    "Join the Mr-Reel community today and take your online gaming experience to the next level. With our expert guidance, you can focus on what truly matters—enjoying the thrill of the game!",
    "At Mr-Reel, transparency and player satisfaction are at the heart of what we do. We only feature licensed and regulated casinos that adhere to strict industry standards, ensuring that your gaming experience is not only exciting but also safe and fair.",
  ];

  return (
    <section className="bg-gradient-to-b from-background to-background/95 dark:from-darkbg dark:to-darkbg/95 text-textLight dark:text-textDark py-16 sm:py-20  transition-colors duration-300">
      <div className="w-full mx-auto max-w-[1200px] px-6 sm:px-8 lg:px-10">
        {/* Header */}
        <motion.div
          className="text-center mb-12 sm:mb-16 lg:mb-20"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h6 className="text-3xl  font-extrabold tracking-tight text-gray-900 dark:text-white mb-4">
            Your Trusted Guide to Online Casinos
          </h6>
          <div className="h-1 w-20 bg-gradient-to-r from-primary to-primary/60 mx-auto rounded-full" />
        </motion.div>

        {/* Content */}
        <motion.div
          className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {/* Left Column */}
          <motion.div className="space-y-6" variants={itemVariants}>
            {paragraphs.slice(0, 3).map((paragraph, index) => (
              <motion.p
                key={index}
                className="text-base text-left sm:text-lg leading-relaxed text-gray-700 dark:text-gray-300 transition-colors duration-300"
                variants={itemVariants}
              >
                {paragraph}
              </motion.p>
            ))}
          </motion.div>

          {/* Right Column */}
          <motion.div className="space-y-6" variants={itemVariants}>
            {paragraphs.slice(3).map((paragraph, index) => (
              <motion.p
                key={index + 3}
                className="text-base text-left sm:text-lg leading-relaxed text-gray-700 dark:text-gray-300 transition-colors duration-300"
                variants={itemVariants}
              >
                {paragraph}
              </motion.p>
            ))}
          </motion.div>
        </motion.div>

        {/* Highlight Box */}
        <motion.div
          className="mt-12 sm:mt-16 lg:mt-20 p-6 sm:p-8 lg:p-100 rounded-2xl"
          variants={itemVariants}
          initial="hidden"
          animate="visible"
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <div className="flex gap-4">
            <div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 dark:text-white mb-2">
                Trusted & Transparent
              </h3>
              <p className="text-sm sm:text-base text-gray-700 dark:text-gray-300">
                We only feature licensed and regulated casinos that adhere to
                strict industry standards, ensuring your gaming experience is
                safe, fair, and exciting.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default WelcomeSection;
